//------------------//
// Alpine.js
// https://alpinejs.dev
//------------------//
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse';
global.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.start()




//------------------//
// Lazy load images
// https://github.com/verlok/vanilla-lazyload
//------------------//
import Lazyload from 'vanilla-lazyload';

// Create Lazy load instance
var lazyLoadInstance = new Lazyload({
    elements_selector: '.lazy'
});
global.lazyLoadInstance = lazyLoadInstance;




//------------------//
// Flickity
// https://flickity.metafizzy.co
//------------------//
const Flickity = require('flickity');
require('flickity-imagesloaded');





//------------------//
// Fancybox
// https://fancyapps.com
//------------------//
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
global.Fancybox = Fancybox;

Fancybox.bind("[data-fancybox]", {});





//------------------//
// GSAP animations
//------------------//
import scrollAnimations from './scroll-animations';





//------------------//
// Macy.js
// https://github.com/bigbite/macy.js
//------------------//
import Macy from 'macy';
function initMasonry() {
    const masonryElements = document.querySelectorAll('.masonry').forEach((elem) => {
        const macy = Macy({
            container: elem,
            trueOrder: true,
            margin: 25,
            columns: 3,
            breakAt: {
                1025: 2,
                551: 1
            }
        });
    });
    return masonryElements;
}
initMasonry();
global.initMasonry = initMasonry;




//------------------//
// Rellax.js
// https://dixonandmoe.com/rellax/
//------------------//
import Rellax from 'rellax';
var rellax = new Rellax('.rellax', {
    center: true
});






// Slider sections
const arrow_shape = 'M25.2,25.2c1.3,0,2.6,0.5,3.5,1.4c1.9,1.9,2,5.1,0,7c0,0,0,0,0,0L17.3,45h77.3c2.7,0,5,2.2,5,5s-2.2,5-5,5H17.3l11.4,11.4 c1.9,1.9,1.9,5.1,0,7s-5.1,1.9-7,0L1.9,53.5c-0.5-0.5-0.8-1-1-1.6c-0.3-0.6-0.4-1.2-0.4-1.9c0-0.6,0.1-1.3,0.4-1.9 c0.2-0.6,0.6-1.2,1-1.6l19.8-19.8C22.6,25.7,23.9,25.2,25.2,25.2z';
const slider_sections = document.querySelectorAll('.slider-section');

slider_sections.forEach((slider) => {

    new Flickity(slider, {
        imagesLoaded: true,
        pageDots: false,
        wrapAround: true,
        arrowShape: arrow_shape
    });

});




//------------------//
// WeatherAPI.com
//------------------//
const weatherContainers = document.querySelectorAll('.weather-container');

// Check if weather content is in session storage and if it is, use that if not fetch new data
if (!sessionStorage.getItem('weatherContent')) {
    const apiKey = 'b246dac55e9344b4b8241737232605';
    const locationKey = '38117';
    const apiUrl = `https://api.weatherapi.com/v1/current.json?key=${apiKey}&q=${locationKey}&aqi=no`;
    const iconMap = {
        1000: '/assets/images/weather-icons/sunny.svg',
        1002: '/assets/images/weather-icons/moon.svg',
        1003: '/assets/images/weather-icons/partly-sunny.svg',
        1004: '/assets/images/weather-icons/cloudy-night.svg',
        1006: '/assets/images/weather-icons/cloud.svg',
        1009: '/assets/images/weather-icons/cloud.svg',
        1030: '/assets/images/weather-icons/rainy.svg',
        1063: '/assets/images/weather-icons/rainy.svg',
        1066: '/assets/images/weather-icons/snow.svg',
        1069: '/assets/images/weather-icons/snow.svg',
        1072: '/assets/images/weather-icons/snow.svg',
        1087: '/assets/images/weather-icons/thunderstorm.svg',
        1114: '/assets/images/weather-icons/snow.svg',
        1117: '/assets/images/weather-icons/snow.svg',
        1135: '/assets/images/weather-icons/cloud.svg',
        1147: '/assets/images/weather-icons/cloud.svg',
        1150: '/assets/images/weather-icons/rainy.svg',
        1153: '/assets/images/weather-icons/rainy.svg',
        1168: '/assets/images/weather-icons/rainy.svg',
        1171: '/assets/images/weather-icons/rainy.svg',
        1180: '/assets/images/weather-icons/rainy.svg',
        1183: '/assets/images/weather-icons/rainy.svg',
        1186: '/assets/images/weather-icons/rainy.svg',
        1189: '/assets/images/weather-icons/rainy.svg',
        1192: '/assets/images/weather-icons/rainy.svg',
        1195: '/assets/images/weather-icons/rainy.svg',
        1198: '/assets/images/weather-icons/rainy.svg',
        1201: '/assets/images/weather-icons/snow.svg',
        1204: '/assets/images/weather-icons/snow.svg',
        1207: '/assets/images/weather-icons/snow.svg',
        1210: '/assets/images/weather-icons/snow.svg',
        1213: '/assets/images/weather-icons/snow.svg',
        1216: '/assets/images/weather-icons/snow.svg',
        1219: '/assets/images/weather-icons/snow.svg',
        1222: '/assets/images/weather-icons/snow.svg',
        1225: '/assets/images/weather-icons/snow.svg',
        1237: '/assets/images/weather-icons/snow.svg',
        1240: '/assets/images/weather-icons/rainy.svg',
        1243: '/assets/images/weather-icons/rainy.svg',
        1246: '/assets/images/weather-icons/rainy.svg',
        1249: '/assets/images/weather-icons/snow.svg',
        1252: '/assets/images/weather-icons/snow.svg',
        1255: '/assets/images/weather-icons/snow.svg',
        1258: '/assets/images/weather-icons/snow.svg',
        1261: '/assets/images/weather-icons/snow.svg',
        1264: '/assets/images/weather-icons/snow.svg',
        1273: '/assets/images/weather-icons/thunderstorm.svg',
        1276: '/assets/images/weather-icons/thunderstorm.svg',
        1279: '/assets/images/weather-icons/snow.svg',
        1282: '/assets/images/weather-icons/snow.svg'
    };

    fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
            // console.log(data);
            const temperature = Math.round(data.current.temp_f);
            const weatherIcon = document.createElement('object');
            weatherIcon.setAttribute('type', 'image/svg+xml');
            if (data.current.condition.code === 1000 && data.current.is_day === 0) {
                weatherIcon.setAttribute('data', iconMap[1002]);
            } else if (data.current.condition.code === 1003 && data.current.is_day === 0) {
                weatherIcon.setAttribute('data', iconMap[1004]);
            } else {
                weatherIcon.setAttribute('data', iconMap[data.current.condition.code]);
            }
            weatherIcon.setAttribute('aria-label', `${data.current.condition.text}`);
            weatherContainers.forEach(container => {
                container.innerHTML = `${temperature}° <span class="block w-[15px] h-[15px] ml-p5">${weatherIcon.outerHTML}</span>`;
            });

            // Store the div's HTML content in sessionStorage
            sessionStorage.setItem('weatherContent', weatherContainers[0].innerHTML);
        })
        .catch(error => {
            console.error(error);
    });

} else {
    // Retrieve the div's HTML content from sessionStorage
    const cachedWeatherContent = sessionStorage.getItem('weatherContent');
    // Set the cached content as the div's HTML

    weatherContainers.forEach(container => {
        container.innerHTML = cachedWeatherContent;
    });
}
